<template>
	<div class="view course-detail-view">
		<HeaderBar :titleParam="title">
			<img v-if="!is_collect"
				 class="fav-img"
				 src="../../assets/images/unfav.png"
				 alt="收藏"
				 @click="onFavClick" />
			<img v-else
				 class="fav-img"
				 src="../../assets/images/fav2.png"
				 alt="取消收藏"
				 @click="onUnfavClick" />

			<img class="share-img"
				 src="../../assets/images/share.png"
				 alt="分享"
				 @click="onShareClick" />
		</HeaderBar>
		<div class="cover-wrap"
			 ref="videoWrap">
			<img v-if="!videoSrc"
				 class="cover-img"
				 :src="cover" />
			<!--<div class="mask"></div>
      <img
        class="play-img"
        src="../../assets/images/play_big.png"
        @click="onPlayClick"
      /> -->
			<video-player v-else
						  class="vjs-custom-skin  vjs-big-play-centered vjs--customize"
						  ref="videoPlayer"
						  :options="playerOptions"
						  @ready="playerReadied">
			</video-player>
		</div>
		<van-tabs class="tabs"
				  v-model="active"
				  v-if="fileType===1" style="height:100%;">
			<van-tab title="资源描述">
				<div class="tab-content">
					<div class="intro-wrap">{{ shortDesc }}</div>
					<div class="info-wrap"
						 v-html="desc"></div>
				</div>
			</van-tab>
			<van-tab title="阅读/下载">
				<div class="tab-content">
					<div class="intro-wrap">{{ shortDesc }}</div>
					<ul>
						<li class="section-item"
							v-for="(item, index) in subDir"
							:key="item.section_id"
							@click="onVideoClick(item, index)">
							<div class="wrap left">
								<img class="play-img--small"
									 src="../../assets/images/pdf_small.png" />
								<span class="name">{{ item.title }}</span>
							</div>
							<div class="wrap right">
								<span class="download-btn"
									  v-show="!!item.path&& osType.os === 'android'" @click.stop.prevent="onDownload(item)">下载</span>
							</div>
						</li>
					</ul>
				</div>
			</van-tab>
		</van-tabs>
		<van-tabs class="tabs"
				  v-model="active"
				  v-if="fileType===2"  style="height:100%;" >
			<van-tab title="课程介绍">
				<div class="tab-content">
					<div class="intro-wrap">{{ title }}</div>
					<div class="info-wrap"
						 v-html="desc"></div>
				</div>
			</van-tab>
			<van-tab title="课程章节" >
				<div class="tab-content">
					<div class="intro-wrap">{{ title }}</div>
					<ul>
						<li class="section-item"
							v-for="(item) in subDir"
							:key="item.section_id"
							@click="onVideoClick(item)">
							<div class="wrap left">
								<img class="play-img--small"
									 src="../../assets/images/play.png" />
								<span>{{ item.title }}</span>
							</div>
							<div class="wrap right">
								<span v-show="item.is_try_show">可试看</span>
							</div>
						</li>
					</ul>
				</div>
			</van-tab>
		</van-tabs>
		<footer class="footer-wrap">
			<span class="footer-item vip"
				  v-if="is_super === 0" @click="toVip">
				<img class="vip-img"
					 src="../../assets/images/vip.png" />
				<span>成为VIP</span>
			</span>
			<span class="footer-item price"
				  v-if="isPower === 0"
				  @click="onBuyClick">{{
        `直接购买￥${price}`
      }}</span>
			<span class="footer-item share"
				  @click="yqFriend">{{
        isPower ? '分享' : '邀好友-免费学'
      }}</span>
		</footer>
		<SharePanel v-show="shareVisible"
					@cancel="shareVisible = false;" :contentType="contentType" :title="title" :cover="cover" :dataType="3"/>
	</div>
</template>
<script>
import { Tab, Tabs, Dialog } from 'vant';
import { Toast } from 'mint-ui'
import 'video.js/dist/video-js.css';

import { videoPlayer } from 'vue-video-player';
import apiUtil from '../../utils/apiUtil';
import { getUser, getOS } from '../../utils/storageUtil'
import apiConst from '../../consts/apiConst';
import HeaderBar from '../../components/HeaderBar';
import SharePanel from '../../components/SharePanel'
export default {
	name: 'courseDetail',
	components: {
		videoPlayer,
		'van-tabs': Tabs,
		'van-tab': Tab,
		HeaderBar,
		SharePanel
		// NavBar
	},
	data() {
		return {
			id: 0,
			active: 1,
			cover: '',
			desc: '',
			fileType: 0,
			isPower: 1,
			is_super: 1,
			shortDesc: '',
			subDir: [],
			title: '',
			price: 0,
			is_collect: 0,
			playerOptions: {
				autoplay: true,
				muted: false,
				language: 'zh',
				playbackRates: [0.7, 1.0, 1.5, 2.0],
				sources: [
					{
						type: 'video/mp4',
						src: ''
					}
				],
				poster: ''
			},
			videoSrc: '',
			balance: 0,
			shareVisible: false,
			osType: null,
			user: null,
			contentType:1
		};
	},
	created() {
		const id = this.$route.query.id;
		this.id = id;
		this.initView(id);
		const user = getUser()
		this.user = user;
		this.osType = getOS();
		if (user) {
			this.getProfile();

		}
	},
	mounted() {
		const width = this.$refs.videoWrap.clientWidth;
		const height = this.$refs.videoWrap.clientHeight;
		this.playerOptions = Object.assign({}, this.playerOptions, {
			width,
			height
		});
	},
	methods: {
		async initView(id) {
			const res = await apiUtil.post(apiConst.getCourseDetail, {
				course_id: id
			});
			if (res.list) {
				const {
					cover,
					desc,
					file_type,
					buy_info: { is_super, shop_price, member_price },
					is_power,
					short_desc,
					sub_dir,
					title
				} = res.list;
				this.cover = cover;
				this.desc = desc;
				this.fileType = file_type;
				this.isPower = is_power;
				this.shortDesc = short_desc;
				this.subDir = sub_dir;
				this.title = title;
				document.title = this.title
				this.is_super = is_super;
				this.price =
					is_super === 0 ? shop_price : is_super === 1 ? member_price : 0;
				this.is_collect = res.is_collect;
				// this.playerOptions= Object.assign({}, this.playerOptions, {
				//   poster: cover
        // })
        
        // 加载详情后自动播放第一个视频（如果满足权限的话）
        if(this.user && this.isPower === 1 && file_type === 2 && sub_dir.length > 0) {
          this.onPlayClick();
        }
			}
		},

		async getProfile() {
			const res = await apiUtil.post(apiConst.getProfile);
			if (res.success) {
				this.balance = res.integration;
			}
		},

		async onFavClick() {
			const res = await apiUtil.post(apiConst.submitFav, {
				id: this.id,
				type: 3
			});
			if (res.success) {
				this.is_collect = 1;
				Toast({
					message: '收藏成功',
					duration: 1000,
					background: '#8FC31E'
				});
			}
		},

		async onUnfavClick() {
			const res = await apiUtil.post(apiConst.submitUnfav, {
				id: this.id,
				type: 3
			});
			if (res.success) {
				this.is_collect = 0;

				Toast({
					message: '已取消收藏',
					duration: 1000,
					background: '#8FC31E'
				});
			}
		},

		playsinline(){
			const ua = navigator.userAgent.toLocaleLowerCase();
			if (ua.match(/tencenttraveler/) != null || ua.match(/qqbrowse/) != null) {
				return false
			}else{
				return true             
			}
		},

		onPlayClick() {
			const item = this.subDir[0];
			if (item && item.path) {
				this.onVideoClick(item);
			}
		},

		onVideoClick(item, index) {
			if (!this.user) {
				this.$router.push('login')
			} else if (this.isPower !== 1) {
				Dialog.alert({
					message: '请先购买该课程'
				}).then(() => {
					return;
				});
			} else {
				if (this.fileType === 2) { // mp4
					const sources = [
						{
							type: 'video/mp4',
							src: item.path
						}
					];
					this.videoSrc = item.path;
					this.playerOptions = Object.assign({}, this.playerOptions, {
						sources,
						poster: item.cover
					});
				} else if (this.fileType === 1) {
					// window.open(path, '_blank')
					this.$router.push({ name: 'pdfViewer', query: { type: 3, id: this.id, index } })
				}
				this.submitStatistics(item.section_id)
			}
		},

		async submitStatistics(dir_id) {
			const res = await apiUtil.post(apiConst.submitStatistics, {
				dir_id: dir_id,
			});
			if (res.success) {
				console.log('dir_id')
			}
		},

		async onBuyClick() {
			if (this.balance < this.integration) {
				Toast({
					message: '余额不足，请充值',
					duration: 1000,
				});
			} else {
				const res = await apiUtil.post(apiConst.submitBuyCourse, {
					course_id: this.id
				})
				if (res.success) {
					Toast({
						message: '购买成功',
						duration: 1000,
					});
					setTimeout(function(){
						window.location.reload();
					},1500);
				}
			}

		},
		
		async onDownload(item){
			// const res = apiUtil.post(apiConst.submitDownload, {dir_id: item.section_id});
			// if(res.success){
			// 	console.log(res)
			// },
			let path = item.path;
			window.HostApp.downFile(path);
		},

		onShareClick() {
			this.contentType = 1;
			this.shareVisible = true;
		},
		yqFriend(){
			this.shareVisible = true;
			this.contentType = 2;
		},
		// player is ready
		playerReadied(player) {
			// seek to 10s
			console.log('example player 1 readied', player);
			player.currentTime(10);
			// console.log('example 01: the player is readied', player)
		},
		toVip(){
			this.$router.push({
				name:'open'
			})
		}
	}
};
</script>
<style lang="stylus" scoped>
.course-detail-view {
	height: 100%;
	// overflow:auto;
	.tabs{
		height: calc(100vh - 528px) !important;
    overflow-y: auto;
	}
	.cover-wrap {
		position: relative;
		height: 440px;
		margin-bottom: 15px;
		.cover-img {
			display: block;
			width: 100%;
			height: 100%;
		}

		.mask {
			position: absolute;
			width: 100%;
			height: 100%;
			left: 0;
			top: 0;
			background-color: rgba(0, 0, 0, 0.4);
		}

		.play-img {
			width: 130px;
			height: 130px;
			position: absolute;
			left: 0;
			right: 0;
			bottom: 0;
			top: 0;
			margin: auto;
		}

		.video-player {
			width: 100%;
			height: 100%;
		}

		.vjs--customize {
			.vjs-control-bar{
				height: 6.0em;
			}
			.vjs-control{
				width: 8em;
			}
		}
	}

	.tab-content {
		padding: 25px 25px 100px 25px;

		.intro-wrap {
			padding: 0 38px;
			height: 88px;
			line-height: 88px;
			background: rgba(248, 249, 254, 1);
			color: #666;
			font-size: 30px;
			overflow: hidden;
			white-space: nowrap;
			text-overflow: ellipsis;
			text-align:center;
		}

		.info-wrap {
			padding-top: 20px;
			color: #333;
			font-size: 30px;
			text-align: justify;
			line-height: 54px;
			padding-bottom: 100px;
			overflow-y: auto;
			-webkit-overflow-scrolling: touch;
			max-height: 650px;
		}

		.section-item {
			height: 88px;
			padding: 0 15px;
			display: flex;
			align-items: center;
			justify-content: space-between;
			border-bottom: 1PX solid #F1F1F1;
			.left {
				display: flex;
				align-items: center;
				font-size: 28px;
				color: #666;

				.name {
					display: inline-block;
					max-width: 500px;
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
				}

				.play-img--small {
					width: 42px;
					height: 42px;
					margin: 0 11px 0 0;
				}
			}

			.right {
				.download-btn {
					display: inline-block;
					width: 108px;
					height: 46px;
					line-height: 46px;
					text-align: center;
					background: #43474D;
					border-radius: 23px;
					font-size: 26px;
					color: #fff;

					&::before {
						content: '';
						display: inline-block;
						vertical-align: middle;
						width: 0;
						height: 100%;
						margin-top: 1PX;
					}
				}
			}
		}
	}

	.footer-wrap {
		position: sticky;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 99;
		height: 100px;
		display: flex;

		.footer-item {
			display: flex;
			align-items: center;
			justify-content: center;
			flex: 1;
			color: #fff;
			background-color: #fff;
			font-size: 30px;

			&.vip {
				flex: 0 0 150px;
				flex-direction: column;
				color: #333;
				font-size: 20px;

				.vip-img {
					width: 56px;
					height: 56px;
				}
			}

			&.price {
				background-color: #8FC31E;
			}

			&.share {
				background-color: #43474D;
			}
		}
	}
}
</style>
<style scoped>
.course-detail-view .info-wrap >>> img {
	max-width: 100%;
	height: auto !important;
	display: block;
	margin: auto;
}

.course-detail-view .info-wrap >>> p {
	margin: 0;
	padding: 0;
}

</style>

